define.alias("ember-style-modifier/modifiers/style", "settings/modifiers/style");